import { ToastOptions } from 'react-hot-toast';

export const AppToastInfoOption: ToastOptions = {
  style: {
    backgroundColor: '#FFFFFF',
    color: '#333333',
    flex: 1,
    textAlign: 'center',
  },
  duration: 2000,
  position: 'top-center',
};

export const AppToastErrorOption: ToastOptions = {
  style: {
    backgroundColor: '#FFFFFF',
    color: '#333333',
    // backgroundColor: '#ED676A',
    // color: '#FFFFFF',
    flex: 1,
    textAlign: 'center',
  },
  duration: 2000,
  position: 'top-center',
};

export const AppToastGameInfoOption: ToastOptions = {
  style: {
    backgroundColor: '#FFFFFF',
    color: '#333333',
    flex: 1,
    textAlign: 'center',
    marginBottom: '85px',
  },
  duration: 2000,
  position: 'bottom-center',
};

export const AppToastGameErrorOption: ToastOptions = {
  style: {
    backgroundColor: '#ED676A',
    color: '#FFFFFF',
    flex: 1,
    textAlign: 'center',
    marginBottom: '85px',
  },
  duration: 2000,
  position: 'bottom-center',
};
